import React, {useContext,useEffect,useState} from 'react'
import {TextField, CircularProgress, Box ,Grid,makeStyles,Badge,Backdrop,IconButton} from "@material-ui/core";
import Axios from 'axios'
import { tramitesContext } from '../contexto/TramitesContext'
import {gql,useQuery,useMutation} from '@apollo/client'
import {useContextoGlobal} from '../../../Context/contextoGlobal';
import moment from 'moment';
import EditIcon from '@mui/icons-material/Edit';
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import MessageIcon from '@mui/icons-material/Message';
import PostAddIcon from '@mui/icons-material/PostAdd';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import WarningIcon from '@mui/icons-material/Warning';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ArrowLeftIcon from '@mui/icons-material/ArrowLeft';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import {transformarFechaTramiteCompleta,transformarFechaTramiteSimple} from '../../../Helpers/fechas'
import {eliminarArchivos, hacerFoco,doPostFile} from '../../../Helpers/utilidades-globales'
import Alert from '@mui/material/Alert';
import Swal from 'sweetalert2';
import { Acciones } from './Acciones';
// import { InfoAutonomiaNew } from './modulos/infoAutonomiaNew';
// import { InfoAnexoNew } from './modulos/InfoAnexoNew';
// import { InfoAscensoNew} from './modulos/InfoAscensoNew';
// import { InfoMinistroNew} from './modulos/InfoMinistroNew';
// import { InfoIglFormacionNew } from './modulos/InfoIglFormacionNew';
// import { InfoPatrocinadoNew } from './modulos/InfoPatrocinadoNew';
import { TR_AnexoNew } from './modulos/TR_AnexoNew';
import { TR_AfiliacionNew  } from './modulos/TR_AfiliacionNew';
import { TR_AscensoNew } from './modulos/TR_AscensoNew';
import { TR_AutonomiaNew } from './modulos/TR_AutonomiaNew';
import { TR_IglFormacionNew } from './modulos/TR_IglFormacionNew';
import { TR_MinistroNew } from './modulos/TR_MinistroNew';
import { TR_PatrocinadoNew } from './modulos/TR_PatrocinadoNew';
import {usuario_habilitado_sede} from '../funcionesGenerales';
import { getToken } from '../../../Helpers/auth-helpers';

import {puedeEditarse,
    mensajeSegunCambios,
    condicionesCumplicadasParaElEstado,
    estadosPosiblesConComentarios,
    mapearTipo,
    tratamientodeAprobacion,
    grabarAprobacionAfiliacion,
    grabarAprobacionNuevoMinistro,
    grabarAprobacionIglFormacion,
    grabarAprobacionAnexo,
    grabarAprobacionAutonomia,
    grabarAprobacionAscenso,objestados,
    esUnRechazo,
    esReversionDeEstado} from '../funcionesGenerales';
import { XCircleIcon } from '@heroicons/react/24/outline';
import { Button, Input, Spinner, Typography } from '@material-tailwind/react';
import Main from '../../../componentes/Main';
import Ventana from '../../../componentes/Ventana';

const regex_solo_numeros = /[0-9]+$/;
const class_historial_tramite = "max-h-none md:max-h-[180px] overflow-y-visible md:overflow-y-auto pr-1 md:pr-2 relative pl-8 border-l border-slate-200 space-y-4 ml-2 scrollbar-thin scrollbar-thumb-slate-200 scrollbar-track-transparent"

export const TramiteNuevo = ({id_tramite,finalizar})=>{

  const {usuario,snackbar} = useContextoGlobal();
  const [loadingFile,setLoadingFile] = React.useState(false);
const [historialesExpandidos, setHistorialesExpandidos] = useState(false);
  let adjuntos = [];

const GET_LISTADO = gql`
query listado ($codigo:String) {
    tramiteInfo(codigo: $codigo){
      _id,
      tipo,
      region,
      fecha,
      distrito{
        id,
        nombre
      },
      ministro{
        nombre,
        id
      }
      status{
        texto,
        fecha,
        usuario{
            nombre
        }
      },
      codigo_web,
      descripcion,
      observaciones{
        texto,
        fecha,
        usuario{
            nombre
        }
      },
      archivado,
      eliminado,
      respuesta{
        texto,
        fecha,
        leido,
        fechaLeido,
        usuario{
            nombre
        }
      }
    }
    }

`;

/* atención podría pasar a una matation de graphql un objeto como parametro pero para ello
hay que crear un type input con GraphQLInputObjectType
*/

const ELIMINAR_TRAMITE = gql`
    mutation eliminarTramite($id:ID!,
                      $usuario:String!,
                      $id_usuario:Int!,
                      $observaciones:String!){
        eliminarTramite(
            id:$id,
            usuario:$usuario,
            id_usuario:$id_usuario,
            observaciones:$observaciones,
        )
    }
`
const MODIFICAR_TRAMITE = gql`
mutation updateTramiteV2($id:ID!,
                      $region:Int,
                      $distrito:String,
                      $distrito_id:Int,
                      $usuario:String!,
                      $usuario_id:Int!,
                      $status:String,
                      $respuesta:String,
                      $observaciones:String,){
                          updateTramiteV2(
                                id:$id,
                                usuario:$usuario,
                                id_usuario:$usuario_id,
                                region:$region,
                                distrito:$distrito,
                                distrito_id:$distrito_id,
                                respuesta:$respuesta,
                                observaciones:$observaciones,
                                status:$status
                            )}`;


   const {loading,error,data} = useQuery(GET_LISTADO,{variables:{codigo:id_tramite},  fetchPolicy: "network-only",
    onError:(err)=>alert(err.message)})
   
    const useStyle = makeStyles({
        select: {
            background: 'white',
            color:'black'
        }
      });

    const classes = useStyle();

  const [updateTramiteV2,{data:data2,loading:loading2}] = useMutation(MODIFICAR_TRAMITE)

  const [eliminarTramite,{data:data3,loading:loading3}] = useMutation(ELIMINAR_TRAMITE)

 const eliminarUnTramite  = async (datos)=>{

    try{
        const {data} = await eliminarTramite({variables:{id:datos.id,
                                                usuario:datos.usuario,
                                                id_usuario:datos.id_usuario,
                                                observaciones:datos.observaciones},
                                                refetchQueries:[GET_LISTADO],
                                                onCompleted:()=>finalizar(true)
                                            })
        snackbar.showMessage(data.eliminarTramite)
    }catch(err){
        console.log(JSON.stringify(err))
        console.log(err.message) // Response not successful: Received status code 500
 
        if(err?.networkError?.result?.errors){
         snackbar.showMessage(err?.networkError?.result?.errors?.reduce((acum,item)=>{return `${acum} ${item.message}`},''),'error')
        }else{
         snackbar.showMessage(err?.message || JSON.stringify(err) || 'Error al ejecutar la operación.','error')
        }
    }
 }



 const iniciarEliminacion = async (datos)=>{

 // NO PUDE IMPLEMNETAR EL SWAL CON INPUT PORQUE QUEDA DEBAJO DEL ALERT DE MUI Y NO SE PUEDE
 // EDITAR EL INPUT, Hay que ver como ponerlo en primer plano.
 // Provisoriamente dejo eliminar sin observaciones...

    /*const { value: observacion ,isConfirmed,isDismissed } = await Swal.fire({
        html: '<p>Por favor ingrese una observación que explique el motivo de la eliminación</p>',
        width: 400,
        input: 'text',
        inputLabel: 'Observación',
        inputPlaceholder: 'Observación',
        showCancelButton: true,
        customClass:{input:'input-rec-id'},
        inputAttributes: {
          maxlength: 10,
          autocapitalize: 'off',
          autocorrect: 'off'
        }})

            
        if (isConfirmed){
            if (observacion){
                eliminarUnTramite({...datos,observacion})
                .then((resultado)=>{
                    Swal.fire({
                        icon: 'alert',
                        title: 'EEEEEE',
                        html: `<p>${JSON.stringify(resultado)}</p>`,
                    })
                })
                .catch(err=>{
                    Swal.fire({
                        icon: 'error',
                        text: err
                    })
                })
            }else{
                Swal.fire({
                    icon: 'error',
                    html: '<p>Para eliminar un trámite ingrese una obsevación que explique el motivo de la eliminación</p>',
                  })
            }       
        }*/

    Swal.fire({
        text:"Por favor confirme la eliminación del trámite",
        showCancelButton:true,
        confirmButtonText:'Eliminar',
        cancelButtonText:'Cancelar'
    }).then(
        resultado=>{
            if (resultado.value){
                eliminarUnTramite(datos);
            }else{
                console.log("Se canceló la operación de la solicitud")
            }
        }
    )

}

  const grabar = async (values)=>{

    try{
       const {data} = await updateTramiteV2({variables:{...values,
                                                        usuario:usuario.nombre,
                                                        usuario_id:usuario.id_usuario,
                                                        id:id_tramite},
                                                        refetchQueries:[GET_LISTADO],
                                                        onCompleted: (result) => {
                                                            if(values.ascenso){ // solo viene este objeto cuando se aprueba
                                                                grabarAprobacionAscenso(values.ascenso)
                                                                .catch(err=>{
                                                                    snackbar.showMessage(err.message,'error')
                                                                })  
                                                            }

                                                            if(values.autonomia){ // solo viene este objeto cuando se aprueba
                                                                grabarAprobacionAutonomia(values.autonomia)
                                                                .catch(err=>{
                                                                    snackbar.showMessage(err.message,'error')
                                                                })  
                                                            }
                                                           
                                                            if(values.anexo){ // solo viene este objeto cuando se aprueba
                                                                grabarAprobacionAnexo(values.anexo)
                                                                .catch(err=>{
                                                                    snackbar.showMessage(err.message,'error')
                                                                })  
                                                            }

                                                            if(values.iglesiaFormacion){ // solo viene este objeto cuando se aprueba
                                                                grabarAprobacionIglFormacion(values.iglesiaFormacion)
                                                                .catch(err=>{
                                                                    snackbar.showMessage(err.message,'error')
                                                                })  
                                                            }

                                                            if(values.nuevo_ministro){ // solo viene este objeto cuando se aprueba
                                                                grabarAprobacionNuevoMinistro(values.nuevo_ministro)
                                                                .catch(err=>{
                                                                    snackbar.showMessage(err.message,'error')
                                                                })  
                                                            }

                                                            if(values.afiliacion){ // solo viene este objeto cuando se aprueba
                                                                grabarAprobacionAfiliacion(values.afiliacion)
                                                                .catch(err=>{
                                                                    snackbar.showMessage(err.message,'error')
                                                                })  
                                                            }
                                                          },})
       return true // para el formulario formik asi luego de cambiar de estado puede resetarse
   }catch(err){
       console.log(JSON.stringify(err))
       console.log(err.message) // Response not successful: Received status code 500

       if(err?.networkError?.result?.errors){
        snackbar.showMessage(err?.networkError?.result?.errors?.reduce((acum,item)=>{return `${acum} ${item.message}`},''),'error')
       }else{
        snackbar.showMessage(err?.message || JSON.stringify(err) || 'Error al ejecutar la operación.','error')
       }

       return false
   }

  }

 useEffect(()=>{
 },[data])

    if(loading2 || loading){
       return  <Main center alinear>
                    <div className='flex flex-col justify-center items-center h-[calc(100vh-10rem)]'>
                        <Spinner className="h-12 w-12" />
                        <span className="cargando font-semibold text-[15px]">Cargando...</span>
                    </div>
                </Main>
    }

    return <Grid container spacing={2}>
      
    <Grid item xs={12}>
        <InfoTramite id={data.tramiteInfo._id} 
                    cabecera={data.tramiteInfo} 
                    usuario={usuario}
                    dataTramite={data} 
                    grabar={grabar}
                    eliminar={iniciarEliminacion}
                    snackbar={snackbar}
                    finalizar={finalizar}/>   
    </Grid>
   
  </Grid>
}


// const HistorialStatus = ({ vector }) => {
//   // Validación al principio para evitar errores de copia si el vector no existe
//   if (!vector || vector.length === 0) return null;

//   const copia = [...vector];
//   const arrayordenado = copia.sort((a, b) => Number(b.fecha) - Number(a.fecha));

//   return (
//     <div className="w-full bg-slate-50 border border-slate-200 rounded-xl p-4 shadow-sm">
//       <h5 className="text-xs font-bold uppercase tracking-wider text-slate-400 mb-4 flex items-center gap-2">
//         <span className="w-2 h-2 rounded-full bg-blue-500"></span>
//         Historial de Estados
//       </h5>
      
//       {/* Contenedor tipo Timeline */}
//       <div className="relative pl-4 border-l border-slate-200 space-y-4 ml-2">
//         {arrayordenado.map((item, index) => (

//           <div key={index} title={`${index === 0 ? "Estado actual" : ''}`} className={`relative group  ${index === 0 ? "bg-blue-gray-100 p-2" : ''}`}>
//             {/* Pito/Círculo de la línea de tiempo */}
//             <span className="absolute -left-[21px] top-1.5 w-3 h-3 rounded-full bg-white border-2 border-blue-500 group-hover:bg-blue-500 transition-colors"></span>
            
//             <div className="flex flex-col sm:flex-row sm:justify-between sm:items-start gap-1">
//               <div>
//                 <span className="inline-block bg-blue-50 text-blue-700 font-bold text-xs px-2 py-0.5 rounded border border-blue-100">
//                   {item.texto}
//                 </span>
//                 {index === 0 && <ArrowLeftIcon className="w-1 h-1 text-orange-500" />}
//                 <p className="text-xs text-slate-400 mt-1">
//                   Por: <span className="font-medium text-slate-600">{item.usuario.nombre}</span>
//                 </p>
//               </div>
//               <span className="text-[11px] font-mono text-slate-400 whitespace-nowrap">
//                 {transformarFechaTramiteCompleta(Number(item.fecha))}
//               </span>
//             </div>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

const HistorialStatus = ({ vector }) => {
  // Validación al principio para evitar errores de copia si el vector no existe
  if (!vector || vector.length === 0) return null;

  const copia = [...vector];
  const arrayordenado = copia.sort((a, b) => Number(b.fecha) - Number(a.fecha));

  return (
    <div className="w-full bg-slate-50 border border-slate-200 rounded-xl p-4 shadow-sm">
      <h5 className="text-xs font-bold uppercase tracking-wider text-slate-400 mb-4 flex items-center gap-2">
        <span className="w-2 h-2 rounded-full bg-blue-500"></span>
        Historial de Estados ({vector.length})
      </h5>
      {/* Contenedor tipo Timeline */}
      <div className={class_historial_tramite}>
          {arrayordenado.map((item, index) => {
          
          // 1. Buscamos la info del estado usando el nombre
          const estadoInfo = Object.values(objestados).find(i => i.nombre === item.texto);
          
          // 2. Extraemos los colores limpios de forma segura sin arrastrar el string "border" problemático
          const colorFondo = estadoInfo?.bg[0] || '#E0F2FE';
          const colorTexto = estadoInfo?.bg[2] || '#075985';
          
          // Intentamos extraer el hexadecimal del borde. Si dice "1px solid #HEX", nos quedamos con el #HEX.
          const stringBorde = estadoInfo?.bg[1] || '';
          const colorBorde = stringBorde.includes('#') 
            ? '#' + stringBorde.split('#')[1] 
            : '#7DD3FC'; 

          // 3. Estilo para destacar suavemente el fondo del ESTADO ACTUAL (Index 0)
          const estiloContenedorActual = index === 0 ? {
            backgroundColor: `${colorFondo}80`, // 50% de opacidad
            borderLeftWidth: '4px',
            borderLeftStyle: 'solid',
            borderLeftColor: colorBorde
          } : {};

          return (
            <div 
              key={index} 
              title={index === 0 ? "Estado actual" : ''} 
              className={`relative group rounded-r-lg transition-all duration-200 ${index === 0 ? "p-3 -ml-4 pl-4 shadow-sm" : ''}`}
              style={estiloContenedorActual}
            >
              {/* Pito/Círculo de la línea de tiempo adaptado dinámicamente al color del estado */}
              <span 
                className="absolute -left-[21px] top-2 w-3 h-3 rounded-full bg-white transition-colors group-hover:scale-110"
                style={{
                  borderWidth: '2px',
                  borderStyle: 'solid',
                  borderColor: colorBorde,
                  backgroundColor: index === 0 ? colorBorde : '#ffffff'
                }}
              ></span>
              
              <div className="flex flex-col sm:flex-row sm:justify-between sm:items-start gap-1">
                <div>
                  {/* Badge del estado mapeado sin pasarle la propiedad 'border' directamente */}
                  <span 
                    className="inline-block font-bold text-xs px-2 py-0.5 rounded tracking-wide"
                    style={{
                      backgroundColor: colorFondo,
                      color: colorTexto,
                      borderColor: colorBorde,
                      borderWidth: '1px',
                      borderStyle: 'solid'
                    }}
                  >
                    {item.texto}
                  </span>
                  
                  {index === 0 && (
                    <span className="ml-2 text-[10px] font-black uppercase tracking-wider text-slate-400">
                      (Actual)
                    </span>
                  )}
                  
                  <p className="text-xs text-slate-400 mt-1">
                    Por: <span className="font-medium text-slate-600">{item.usuario.nombre}</span>
                  </p>
                </div>
                
                <span className="text-[11px] font-mono text-slate-400 whitespace-nowrap pt-0.5">
                  {transformarFechaTramiteCompleta(Number(item.fecha))}
                </span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
const HistorialObservaciones = ({ vector, label }) => {
  if (!vector || vector.length === 0) return null;

  const copia = [...vector];
  const arrayordenado = copia.sort((a, b) => Number(b.fecha) - Number(a.fecha));

  return (
    <div className="w-full bg-white border border-slate-200 rounded-xl p-4 shadow-sm">
      <h5 className="text-xs font-bold uppercase tracking-wider text-slate-400 mb-3">
        {label || "Observaciones"}  ({vector.length})
      </h5>
      
<div className={class_historial_tramite}>
          {arrayordenado.map((item, index) => (
          <div key={index} className="bg-amber-50/60 border-l-4 border-amber-500 p-3 rounded-r-lg">
            
            {/* Cabecera de la nota */}
            <div className="flex justify-between items-center mb-1">
              <span className="text-xs font-semibold text-amber-800 bg-amber-100/80 px-2 py-0.5 rounded-full">
                {item.usuario.nombre}
              </span>
              <span className="text-[10px] font-mono text-slate-400">
                {transformarFechaTramiteCompleta(Number(item.fecha))}
              </span>
            </div>
            
            {/* Cuerpo del texto */}
            <p className="text-sm text-slate-700 font-normal leading-relaxed mt-1.5">
              {item.texto}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

const HistorialRespuestas = ({ vector, label }) => {
  if (!vector || vector.length === 0) return null;

  // Excelente tu nota sobre la inmutabilidad del array original. 
  // Efectivamente, con [...vector] lo solucionamos perfecto.
  const copia = [...vector];
  const arrayordenado = copia.sort((a, b) => Number(b.fecha) - Number(a.fecha));

  return (
    <div className="w-full bg-white border border-slate-200 rounded-xl p-4 shadow-sm">
      <h5 className="text-xs font-bold uppercase tracking-wider text-slate-400 mb-3">
        {label || "Respuestas"}  ({vector.length})
      </h5>
      
<div className={class_historial_tramite}>
          {arrayordenado.map((item, index) => (
          <div key={index} className="border border-slate-100 rounded-lg p-3 bg-slate-50/50 hover:bg-slate-50 transition-colors">
            
            {/* Quien responde y Cuándo */}
            <div className="flex justify-between items-start gap-2 mb-2">
              <div>
                <p className="text-xs font-bold text-slate-700">{item.usuario.nombre}</p>
                <p className="text-[10px] font-mono text-slate-400">
                  {transformarFechaTramiteCompleta(Number(item.fecha))}
                </p>
              </div>
              
              {/* Badge de Lectura (Leído / Pendiente) */}
              <div title='Indica si el ministro abrió la notificación en su aplicación ministros.uad.digital' className="flex flex-col items-end">
                {item?.leido ? (
                  <div className="flex items-center gap-1 text-emerald-600 bg-emerald-50 px-2 py-0.5 rounded text-[11px] font-medium border border-emerald-100">
                    <CheckCircleIcon color='success' className="w-3.5 h-3.5" /> Leído
                  </div>
                ) : (
                  <div className="flex items-center gap-1 text-rose-600 bg-rose-50 px-2 py-0.5 rounded text-[11px] font-medium border border-rose-100">
                    <HighlightOffIcon color='warning' className="w-3.5 h-3.5" /> No leído
                  </div>
                )}
              </div>
            </div>

            {/* Mensaje */}
            <p className="text-sm text-slate-600 bg-white border border-slate-100 p-2.5 rounded-md shadow-sm">
              {item.texto}
            </p>

            {/* Subtexto sutil de cuándo se visualizó */}
            {item?.leido && item?.fechaLeido && (
              <p className="text-[10px] text-slate-400 italic mt-1.5 text-right">
                Visto el: {transformarFechaTramiteSimple(Number(item.fechaLeido))}
              </p>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

const InfoTramite = ({id,cabecera,usuario,finalizar,dataTramite,grabar,snackbar,eliminar})=>{

const status_actual_tramite = cabecera.status[cabecera.status.length-1].texto;

const [pedirInfoAdicional,setPedirInfoAdicional] = useState(null)
const [cambiarStatus,setCambiarStatus]=useState(null)
const [observaciones,setObservaciones] = useState(null)
const [respuesta,setRespuesta] = useState(null)
const [dataDetalle,setDataDetalle] = useState(null)

useEffect(()=>{
    if(!cambiarStatus || !pedirInfoAdicional){
        setObservaciones(null)
        setRespuesta(null)
    }
},[cambiarStatus,pedirInfoAdicional])

const estadosX = estadosPosiblesConComentarios(cabecera,usuario)

const iniciarGrabarStatusPlus = (objetoInfoAdicional,observaciones,respuesta)=>{

    let objeto = {status:objetoInfoAdicional.status,observaciones:observaciones}
    
    if(respuesta){
        Object.assign(objeto,{respuesta:respuesta})
    }

    iniciarGrabar(objeto)
}

    const iniciarGrabar = (objeto)=>{
        const validacionEstado = esReversionDeEstado(objeto,status_actual_tramite);
        const validacionRechazo = esUnRechazo(objeto);

        if(!validacionEstado[0]){ // Si se pasa a un estado anterior es obligatorio ingresar una observación interan

            if(!observaciones){
                setPedirInfoAdicional({operacion:validacionEstado[2],texto:validacionEstado[1],status:validacionEstado[3]})
                return
            }
        }

        if(!validacionRechazo[0]){ // si es un rechazo es obligatorio ingresar una respuesta al ministro y una observaciión interna
            if(!observaciones || !respuesta){ 
                setPedirInfoAdicional({operacion:validacionRechazo[2],texto:validacionRechazo[1],status:validacionRechazo[3]})
                return
            }
        }
        
        if(objeto?.status==objestados.aprobado.nombre){
                tratamientodeAprobacion(objeto,dataTramite,dataDetalle,grabar,snackbar,usuario)
        }else{
            const mensajes = objeto.status ? mensajeSegunCambios(objeto,dataTramite) : ''

            Swal.fire({
                html:`<Div>Por favor confirme la modificación
                    ${mensajes ? `<p>${mensajes}</p>`:''}
                </Div>`,
                showCancelButton:true,
                confirmButtonText:'Modificar',
                cancelButtonText:'Cancelar'
            }).then(
                resultado=>{
                    if (resultado.value){
                        grabar2(objeto);
                    }else{
                        console.log("Se canceló la operación de la solicitud")
                    }
                }
            )
        }

    }

    const subirAdjunto = async (file,solicitante,identificador,adjuntos)=>{

        try{
    
          const resultado_acta = await doPostFile(file,{id_obrero:solicitante},`${identificador}`,'pdf')
          
          adjuntos.push(resultado_acta[1] || 'unknown')
    
          if(!resultado_acta[0])
          {
            //setLoadingFile(false)
            eliminarArchivos(adjuntos)
            return [false,resultado_acta[1]]
          }
          
          //setLoadingFile(false)
    
          return [true,{
            acta:resultado_acta[1]
          }]
    
        }catch(err){
          //setLoadingFile(false)
          console.log(err)
          eliminarArchivos(adjuntos)
          return [false,err?.message || 'Se produjo un error al ejecutar al inicializar el proceso de guardado de datos']
        }
    
    } 

    const grabar2 = (objeto)=>{

        //const condicionOK =  objeto.status ? condicionesCumplidasParaElEstadoGenerico(dataTramite,data,objeto,usuario) : [true];
        // el caso en que objeto.status no está definido es cuando no es un cambio de estado sino una respuesta o una observación
        const condicionOK =  dataDetalle ? objeto.status ? condicionesCumplicadasParaElEstado(dataTramite,dataDetalle,objeto) : [true] : [false,'Faltan los datos del ascenso para validar si se puede ejecutar la modificación'];

        if(!condicionOK[0]){
            snackbar.showMessage(condicionOK[1],'error')
        }else{
                grabar(objeto)
                .then(resultado=>{
                    if(resultado){
                        Swal.fire({
                            text:'Los datos fueron grabados',
                            icon: 'success',
                            timer: 1000,
                            showConfirmButton: false,
                        })   
                    }
                })
        }
       
    }

    const iniciarReactivar = (observaciones)=>{
        //setPedirInfoAdicional({operacion:'reactivar',texto:'Reactivación',status:'test'}) No uso este método porque está pensado para otro tipo de operaciones 
        reactivar(id,observaciones)
         // pedirObservacion() Desisto de usar swal porque al abrirse dentro de un dialog hay conflictos de foco y no se habilita nunca el textarea
    }


const pedirObservacion = async () => {
    return await Swal.fire({
        title: 'Reactivación de trámite rechazado',
        html: '<p style="margin-bottom: 10px;">Por favor ingrese una observación breve</p>',
        input: 'text',
        inputPlaceholder: 'Escriba aquí los motivos de la reactivación...',
        inputValue: '',
        showCancelButton: true,
        confirmButtonText: 'Reactivar',
        cancelButtonText: 'Cancelar',
        confirmButtonColor: '#3085d6',

        focusConfirm: false, // Evita que Swal fuerce el foco al botón confirmar
    returnFocus: false,  // Evita que intente devolver el foco al elemento que lo abrió
didOpen: () => {
            // Un pequeño delay permite que el DOM del Swal se asiente
            // y luego forzamos el foco ignorando al Dialog de abajo
            setTimeout(() => {
                const input = Swal.getInput();
                if (input) {
                    input.click(); // Algunos navegadores necesitan el click para habilitar
                    input.focus();
                }
            }, 200);
        },
        inputValidator: (value) => {
            if (!value) {
                return 'Debe ingresar una observación'; // Mensaje de error si está vacío
            }
            // IMPORTANTE: Si los datos son válidos, NO debes retornar nada (o retornar undefined/null)
            // Si retornas un string como 'prueba', Swal lo interpreta como un mensaje de error y no cierra.
        }
    }).then(async (result) => {
        if (result.isConfirmed) {
            // El valor ingresado está en result.value
            alert(`Observación ingresada: ${result.value}`);
            return result.value; // Retornamos el valor para quien llamó a la función
        } else if (result.dismiss === Swal.DismissReason.cancel) {
            console.log('Reactivación cancelada por el usuario');
            return null;
        }
    });
};

    // const reactivar = async (id,observaciones)=>{
    //     const token = getToken();

    //      try {
    //           //setIsSearching(true);
    //           const { data } = await Axios.post(
    //             `${process.env.REACT_APP_API_UAD_BASE}/api/tramites/reactivar/false/${id}/${token}`,{
    //                 usuario: usuario.nombre,
    //                 id_usuario:usuario.id_usuario,
    //                 motivo:observaciones
    //             }
    //           );

    //         } catch (err) {
    //           console.error("Error:", err);
    //         }
    // }

const reactivar = async (id, observaciones) => {

  const result = await Swal.fire({
    title: '¿Confirma la reactivación del trámite?',
    text: 'Esta acción volverá a activar el trámite seleccionado en estado "En proceso regional"',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Sí, reactivar',
    cancelButtonText: 'Cancelar',
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33'
  });

  if (!result.isConfirmed) return;

  const token = getToken();

  try {

    await Axios.post(
      `${process.env.REACT_APP_API_UAD_BASE}/api/tramites/reactivar/true/${id}/${token}`,
      {
        usuario: usuario.nombre,
        id_usuario: usuario.id_usuario,
        motivo: observaciones
      }
    );

    Swal.fire({
      icon: 'success',
      title: 'Trámite reactivado',
      text: 'La operación se realizó correctamente'
    });

    finalizar(true)

  } catch (err) {
    console.error("Error:", err);

    Swal.fire({
      icon: 'error',
      title: 'Error',
      text: `No se pudo reactivar el trámite (${err.response.data.message})`
    });
  }
};

  return <Box id="solicitud-proceso" className="mx-auto p-4 w-full max-w-7xl min-h-screen">
  <Acciones 
    status_actual_tramite={status_actual_tramite}
    usuarioEsSedeHabilitado={usuario_habilitado_sede(usuario)}
    usuario={usuario}
    iniciarGrabar={iniciarGrabar}
    eliminar={eliminar}
    objestados={objestados}
    iniciarReactivar={iniciarReactivar}
    cabecera={cabecera}
  />

  {/* Cabecera de la solicitud (La que armamos antes) */}
  <Box className="relative bg-slate-50 border border-slate-200 rounded-xl p-4 text-center w-full mt-1 shadow-sm"> 
     
    <div className='grid grid-cols-1 md:grid-cols-4'>
      
        <button onClick={finalizar} title='Cerrar' className="absolute right-4 top-3  text-deep-orange-900 hover:text-rose-500 transition-colors">
        <CancelOutlinedIcon className="h-6 w-6"/>
        </button>
        <div className='col-span-2 relative'>
            <h2 className="text-xl md:text-2xl font-extrabold text-slate-800 mb-1">
            Solicitud de {mapearTipo(cabecera.tipo)} <div className="text-blue-600 text-lg inline-block ml-2"><span>{cabecera.codigo_web}</span></div>
            </h2>
            <p className="text-slate-500 text-sm italic max-w-xl mx-auto mt-2">"{cabecera.descripcion}"</p>
            
         {/* <div title='Estado actual del trámite' className="inline-block bg-blue-500 text-white font-black text-sm px-4 py-2.5 rounded-lg shadow-inner mb-1 mt-2">
            {status_actual_tramite.toUpperCase()}
        </div> */}
        </div>
       
      <div className="bg-white border border-slate-100 p-2 rounded-lg shadow-sm">
        <p className="text-xs text-slate-400 font-medium uppercase">Solicitado por</p>
        <p className="text-sm md:text-base font-semibold text-slate-700">{cabecera.ministro.nombre}</p>
        <p className="text-xs text-slate-500">el {transformarFechaTramiteSimple(Number(cabecera.fecha))}</p>

      </div>
      <div className="bg-white border border-slate-100 p-2 rounded-lg shadow-sm">
        <p className="text-xs text-slate-400 font-medium uppercase">Jurisdicción</p>
        <p className="text-sm md:text-base font-semibold text-slate-700">Región {cabecera.region}</p>
        <p className="text-xs text-slate-500">{cabecera.distrito.nombre}</p>
      </div>
    </div>
    <div className='text-right mr-2 sm:fixed sm:top-0 sm:right-10'>
      <span className='text-xsmall text-gray-600 text-right mr-2 hidden sm:block'>ID {cabecera._id}</span>
        <span className="text-[11px] font-semibold text-slate-400 uppercase tracking-wide">
            Estado:
        </span>
        <span className="ml-1 font-bold text-blue-600 text-sm sm:text-base">
            {status_actual_tramite}
        </span>
    </div>

    {/*!SECTION WARNINGS*/}
    {/* {status_actual_tramite === objestados.iniciado.nombre && usuario.perfil === "region" && cabecera.tipo !== "nuevo_patrocinado" && cabecera.tipo !== "afiliacion" && (
        <p className="text-brown-600 bg-amber-50 border border-amber-200 rounded-md p-2 text-xs font-semibold mt-2">Debe ingresar el trámite a secretaría regional.</p>
    )}
    {status_actual_tramite === objestados.iniciado.nombre && usuario.perfil === "sede" && usuario?.rol_contabilidad > 50 && cabecera.tipo === "afiliacion" && (
        <p className="text-brown-600 bg-amber-50 border border-amber-200 rounded-md p-2 text-xs font-semibold mt-2">Debe ingresar el trámite a tesorería.</p>
    )}
    {!puedeEditarse(estadosX)[0] && <p className="text-brown-600 bg-amber-50 border border-amber-200 rounded-md p-2 text-xs font-semibold mt-2">{puedeEditarse(estadosX)[1]}</p>}
     */}
    {/* {status_actual_tramite === objestados.iniciado.nombre && usuario.perfil === "region" && cabecera.tipo !== "nuevo_patrocinado" && cabecera.tipo !== "afiliacion" && (
        <Warning text = "Debe ingresar el trámite a secretaría regional"/>
    )}
    {status_actual_tramite === objestados.iniciado.nombre && usuario.perfil === "sede" && usuario?.rol_contabilidad > 50 && cabecera.tipo === "afiliacion" && (
        <Warning text = "Debe ingresar el trámite a tesorería."/>
    )}
    {!puedeEditarse(estadosX)[0] && 
      <Warning text =  {puedeEditarse(estadosX)[1]}/>
    }
    {status_actual_tramite==objestados.rechazado.nombre && usuario.perfil === "region" &&
          <Warning te
          xt = "Si necesita reactivar un trámite rechazado solicítelo en sede central"/>
     } */}

     <div className="flex flex-col md:flex-row md:items-stretch gap-2 w-full">
  {status_actual_tramite === objestados.iniciado.nombre && usuario.perfil === "region" && cabecera.tipo !== "nuevo_patrocinado" && cabecera.tipo !== "afiliacion" && (
    <div className="md:flex-1">
      <Warning text="Debe ingresar el trámite a secretaría regional"/>
    </div>
  )}

  {status_actual_tramite === objestados.iniciado.nombre && usuario.perfil === "sede" && usuario?.rol_contabilidad > 50 && cabecera.tipo === "afiliacion" && (
    <div className="md:flex-1">
      <Warning text="Debe ingresar el trámite a tesorería."/>
    </div>
  )}

  {!puedeEditarse(estadosX)[0] && (
    <div className="md:flex-1">
      <Warning text={puedeEditarse(estadosX)[1]}/>
    </div>
  )}

  {status_actual_tramite === objestados.rechazado.nombre && usuario.perfil === "region" && (
    <div className="md:flex-1">
      <Warning text="Si necesita reactivar un trámite rechazado solicítelo en sede central"/>
    </div>
  )}
</div>
    {/* FIN !SECTION WARNINGS*/}
  {puedeEditarse(estadosX)[0] && !cambiarStatus && <AccionesCabecera
      cambiarStatus={cambiarStatus}
      setCambiarStatus={setCambiarStatus}
      cabecera={cabecera}
  />}
    {cambiarStatus && <DetalleDeAccionCabecera
      cambiarStatus = {cambiarStatus}
      setCambiarStatus ={setCambiarStatus}
      estadosX = {estadosX}
      status_actual_tramite = {status_actual_tramite}
      observaciones = {observaciones}
      respuesta = {respuesta}
      setRespuesta = {setRespuesta}
      setObservaciones = {setObservaciones}
      iniciarGrabar = {iniciarGrabar}
      pedirInfoAdicional={pedirInfoAdicional}
      setPedirInfoAdicional={setPedirInfoAdicional}
      iniciarGrabarStatusPlus={iniciarGrabarStatusPlus}
  />}
{/* 
                        <div className=''>
                            {cabecera?.observaciones?.length > 0 && <Box onClick={()=>setCambiarStatus('consulta_obs')} style={{marginTop:'10px',cursor:'pointer'}}><Badge color="secondary" badgeContent={cabecera.observaciones.length}>
                                <p>Observaciones</p><MessageIcon/>
                                </Badge>
                            </Box>}
                            {!puedeEditarse(estadosX)[0] && <>
                            {cabecera?.respuesta?.length > 0 && <Box onClick={()=>setCambiarStatus('consulta_resp')} style={{marginTop:'10px',cursor:'pointer'}}><Badge color="secondary" badgeContent={cabecera.respuesta.length}>
                                <p>Respuestas</p><MessageIcon/>
                                </Badge>
                            
                            </Box>}
                            {cabecera?.status?.length > 0 && <Box onClick={()=>setCambiarStatus('consulta_status')} style={{marginTop:'10px',cursor:'pointer'}}><Badge color="secondary" badgeContent={cabecera.status.length}>
                                <p>Estados</p><MessageIcon/>
                                </Badge>
                            
                            </Box>}
                            </>}
                        </div> */}
  </Box>

<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 text-left mt-2 pt-2 md:items-stretch">
              <HistorialStatus vector={cabecera.status} />
              <HistorialObservaciones label="Observaciones" vector={cabecera.observaciones}/>
              <HistorialRespuestas label="Respuestas" vector={cabecera.respuesta}/>
     </div>
<div className="flex flex-col gap-6 mt-1 w-full items-stretch">
    {cabecera.tipo=='ascenso' && <TR_AscensoNew
                id={id}
                setData={setDataDetalle}
                cabecera={cabecera}
                usuario={usuario}
                finalizar={finalizar}
                snackbar={snackbar}
                puedeEditarse={puedeEditarse(estadosX)[0]}
                cambiarStatus={()=>setCambiarStatus('estado')}
            />}

    {cabecera.tipo=='nuevo_ministro' && <TR_MinistroNew
                id={id}
                setData={setDataDetalle}
                cabecera={cabecera}
                usuario={usuario}
                finalizar={finalizar}
                snackbar={snackbar}
                puedeEditarse={puedeEditarse(estadosX)[0]}
                cambiarStatus={()=>setCambiarStatus('estado')}
            />}    
 
    {cabecera.tipo=='afiliacion' && <TR_AfiliacionNew
                id={id}
                setData={setDataDetalle}
                cabecera={cabecera}
                usuario={usuario}
                finalizar={finalizar}
                snackbar={snackbar}
                puedeEditarse={puedeEditarse(estadosX)[0]}
                cambiarStatus={()=>setCambiarStatus('estado')}
            />}                       

     {cabecera.tipo=='nuevo_patrocinado' && <TR_PatrocinadoNew
                id={id}
                setData={setDataDetalle}
                cabecera={cabecera}
                usuario={usuario}
                finalizar={finalizar}
                snackbar={snackbar}
                puedeEditarse={puedeEditarse(estadosX)[0]}
                cambiarStatus={()=>setCambiarStatus('estado')}
            />}            
    
      {cabecera.tipo=='autonomia' && <TR_AutonomiaNew
        id={id}
        setData={setDataDetalle}
        cabecera={cabecera}
        usuario={usuario}
        finalizar={finalizar}
        snackbar={snackbar}
        puedeEditarse={puedeEditarse(estadosX)[0]}
        cambiarStatus={()=>setCambiarStatus('estado')}
    />}

      {cabecera.tipo=='igl_formacion' && <TR_IglFormacionNew
          id={id}
          setData={setDataDetalle}
          cabecera={cabecera}
          usuario={usuario}
          finalizar={finalizar}
          snackbar={snackbar}
          puedeEditarse={puedeEditarse(estadosX)[0]}
          cambiarStatus={()=>setCambiarStatus('estado')}
      />}            

      {cabecera.tipo=='anexo' && <TR_AnexoNew
          id={id}
          setData={setDataDetalle}
          cabecera={cabecera}
          usuario={usuario}
          finalizar={finalizar}
          snackbar={snackbar}
          puedeEditarse={puedeEditarse(estadosX)[0]}
          cambiarStatus={()=>setCambiarStatus('estado')}
      />}            

</div>

</Box>
}


const EditarTexto = ({ texto, campo, updateTexto, label, iniciarGrabar, id }) => {
    const objetoUpdate = {};
   
    useEffect(() => {
        updateTexto(null);
        setTimeout(() => {
            hacerFoco("tr-texto-update");
        }, 500);
    }, [id, label]);

    const grabar = () => {
        objetoUpdate[campo] = texto;
        iniciarGrabar(objetoUpdate);
    };

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', marginTop: !id ? '10px' : '' }} className="w-full">
            {/* Etiqueta del campo */}
            <Typography
                variant="small"
                color="blue-gray"
                className="mb-1 font-semibold text-slate-600 text-left"
            >
                {label}
            </Typography>
            
            {/* Cuadro de texto (Textarea / Input multiline) */}
            <Input 
                multiline 
                id="tr-texto-update" 
                value={texto || ''} 
                style={{ color: 'black' }}
                onChange={(e) => updateTexto(e.target.value)} 
                color="black"
                className="bg-slate-50/50 p-2 rounded-lg border border-slate-200 focus:bg-white transition-colors"
                labelProps={{
                    className: "before:content-none after:content-none",
                }}
            />
            
            {/* BOTÓN DE ACCIÓN: Ahora alineado a la derecha y compacto */}
            {iniciarGrabar && texto?.length > 0 && (
                <Button 
                    startIcon={<ArrowRightAltIcon />} 
                    variant="contained" 
                    color="primary"
                    onClick={grabar}
                    // self-end: lo empuja al final de la fila (derecha)
                    // sm:w-auto: en pantallas normales ocupa solo su tamaño
                    className="mt-3 self-end w-full sm:w-auto px-6 font-bold shadow-sm"
                    style={{ textTransform: 'none' }}
                >
                    Grabar
                </Button>
            )}
        </Box>
    );
};



const Warning =({text})=>{
  return <div className='mt-6 sm:fixed sm:top-0'>
    <WarningIcon className="w-1 h-1 text-orange-500" />
    <span className="text-brown-600 bg-amber-50 border border-amber-200 rounded-md p-2 text-xs font-semibold mt-2">{text}</span>
  </div>
}

const AccionesCabecera = ({cambiarStatus,setCambiarStatus,cabecera})=>{
  return <div className="w-full bg-slate-50 p-2 rounded-xl flex flex-col sm:flex-row items-center gap-3 shadow-sm">
      
      {/* Etiqueta lateral */}
      <p className="text-xs text-slate-400 font-bold uppercase tracking-wider shrink-0 sm:border-r sm:border-slate-200 sm:pr-4 sm:mr-2">
        Acciones
      </p>
      
      {/* Grupo de botones en fila horizontal (sm:flex-row) */}
      <div className="flex flex-col sm:flex-row gap-2 w-full">
        <Button 
          variant={cambiarStatus === 'estado' ? 'contained' : 'outlined'} 
          color="primary" 
          fullWidth 
          onClick={() => setCambiarStatus('estado')}
        >
          Cambie el estado del trámite
        </Button>
        
        <Button 
          variant={cambiarStatus === 'observacion' ? 'contained' : 'outlined'} 
          color="primary" 
          fullWidth 
          onClick={() => setCambiarStatus('observacion')}
        >
          Ingrese una observación
        </Button>
        
        {cabecera.tipo !== 'igl_formacion' && (
          <Button 
            variant={cambiarStatus === 'respuesta' ? 'contained' : 'outlined'} 
            color="primary" 
            fullWidth 
            onClick={() => setCambiarStatus('respuesta')}
          >
            Envíe una respuesta al ministro
          </Button>
        )}
      </div>
    </div>
}

const DetalleDeAccionCabecera = ({cambiarStatus,
                                  setCambiarStatus,
                                  estadosX,
                                  status_actual_tramite,
                                  observaciones,
                                  respuesta,
                                  setRespuesta,
                                  setObservaciones,
                                  iniciarGrabar,
                                  pedirInfoAdicional,
                                  setPedirInfoAdicional,
                                iniciarGrabarStatusPlus})=>{


const se_requiere_observacion = pedirInfoAdicional?.operacion=='obs_status_menor' 
                    || pedirInfoAdicional?.operacion=='obs_eliminacion'
                    || pedirInfoAdicional?.operacion=='obs_resp_rechazo';

const se_requiere_respuesta = pedirInfoAdicional?.operacion=='obs_resp_rechazo'

let condicion_grabar_cumplida = false;

if(se_requiere_observacion && se_requiere_respuesta){
  condicion_grabar_cumplida = respuesta?.length > 0 && observaciones?.length > 0;
}else if(se_requiere_observacion){
  condicion_grabar_cumplida = observaciones?.length > 0;
}else if(se_requiere_respuesta){
  condicion_grabar_cumplida = respuesta?.length > 0;
}



  return     <div className="w-full bg-white border-2 border-blue-500/20 rounded-xl p-5 shadow-md relative animate-fadeIn">
      {/* Cabecera del panel de inputs */}
      <div className="flex justify-between items-center mb-4 pb-2 border-b border-slate-100">
        {/* <span className="text-xs font-bold uppercase tracking-widest text-blue-600 bg-blue-50 px-2.5 py-1 rounded">
          Detalle de la acción: {cambiarStatus.replace('_', ' ')}
        </span> */}
        <button 
          onClick={() => {setCambiarStatus(null);setPedirInfoAdicional(null)}} 
          className="text-slate-400  text-deep-orange-900 hover:text-rose-500 p-1 rounded-full hover:bg-slate-100 transition-colors"
          title="Cerrar"
        >
          <CancelOutlinedIcon className="h-5 w-5"/>
        </button>
      </div>

      {/* Sub-sección: Selección de nuevo Estado */}
      {cambiarStatus === 'estado' && (
        <div className="text-left">
          
          {!pedirInfoAdicional && <>
            <h1>Estado actual: <span className='text-orange-900'>{status_actual_tramite}</span></h1>
            <p className="text-sm text-slate-600 mb-3 mt-2 font-medium">Seleccione el nuevo estado para este trámite:</p>
                    
                  
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-2 max-h-[250px] overflow-y-auto pr-1">
            {estadosX.estados
              .filter(item => item[0] !== status_actual_tramite)
              .map((item, index) => {
                // 1. Buscamos el objeto del estado completo una sola vez por cada iteración
                const estadoInfo = Object.values(objestados).find(i => i.nombre === item[0]);

                // 2. Extraemos los colores del array 'bg' [fondo, borde, texto] si existe
                const colorFondo = estadoInfo?.bg?.[0] || '#F1F5F9'; // Gris por defecto por seguridad
                const colorBorde = estadoInfo?.bg?.[1] || '#CBD5E1';
                const colorTexto = estadoInfo?.bg?.[2] || '#334155';

                return (
                  <Button 
                    key={index}
                    startIcon={<ArrowRightAltIcon style={{ color: colorTexto }} />} 
                    variant="contained" 
                    size="small"
                    // Aplicamos los estilos en base a la posición del array
                    style={{
                      backgroundColor: colorFondo,
                      borderColor: colorBorde,
                      color: colorTexto,
                      borderWidth: '1px',
                      borderStyle: 'solid',
                      fontWeight: 'bold'
                    }}
                    onClick={() => {
                      iniciarGrabar({ status: item[0] });
                      //setCambiarStatus(null);
                    }}
                  >
                    {/* Nombre del estado y su ID al lado (opcional, como lo tenías) */}
                    {item[0]}
                  </Button>
                );
              })}
          </div>
          </>}
           {pedirInfoAdicional && <div className='mt-4 flex flex-col'>
             <Warning text="Por favor confirme el nuevo estado"/>

              <h1 className='mt-4 mb-4'>Nuevo estado: <span className='text-orange-900 border border-slate-200 rounded-xl bg-yellow-600 p-1'>{pedirInfoAdicional?.status}</span></h1>

              <h4 style={{marginBottom:'1rem'}}>{pedirInfoAdicional?.texto}</h4>

            {se_requiere_observacion &&
             <>
                <EditarTexto
                  texto = {observaciones}
                  campo = {'observaciones'}
                  id={'tx-observaciones'}
                  updateTexto = {setObservaciones}
                  label = {'Nueva observación interna'}
                  iniciarGrabar = {null}
                />
              </>}
            {se_requiere_respuesta &&
               <>
                  <EditarTexto
                    texto = {respuesta}
                    campo = {'respuesta'}
                    id={null}
                    updateTexto = {setRespuesta}
                    label = {'Respuesta al ministro'}
                    iniciarGrabar = {null}
                />
              </>}
            
                { condicion_grabar_cumplida && <Button 
                      startIcon={<ArrowRightAltIcon />} 
                      variant="contained" 
                      color="primary"
                      onClick={()=>iniciarGrabarStatusPlus(pedirInfoAdicional,observaciones,respuesta)}
                      // self-end: lo empuja al final de la fila (derecha)
                      // sm:w-auto: en pantallas normales ocupa solo su tamaño
                      className="mt-3 self-end w-full sm:w-auto px-6 font-bold shadow-sm"
                      style={{ textTransform: 'none' }}
                  >
                      Grabar
                </Button>}

           </div> }
        </div>
      )}

      {/* Sub-sección: Inputs de edición de textos */}
      <div id="tramite-texts" className="w-full">
        {(cambiarStatus === 'observacion' || cambiarStatus === 'respuesta') && (
          <EditarTexto
            texto={cambiarStatus === 'observacion' ? observaciones : respuesta}
            campo={cambiarStatus === 'observacion' ? 'observaciones' : 'respuesta'}
            updateTexto={cambiarStatus === 'observacion' ? setObservaciones : setRespuesta}
            label={cambiarStatus === 'observacion' ? 'Ingrese una nueva observación interna' : 'Ingrese una nueva respuesta para el ministro'}
            iniciarGrabar={iniciarGrabar}
          />
        )}
      </div>

    </div>
}